import React from "react";

export default React.createContext<firebase.User | null | undefined>(undefined);
